import { AppIfairQAComponent } from './pages/app-qa/app-ifair-qa.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SiteRoutingModule } from './site-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask'

import { SiteComponent } from './site.component';
import { HomeComponent } from './pages/home/home.component';
import { EmpresaComponent } from './pages/empresa/empresa.component';
import { PropositoComponent } from './pages/proposito/proposito.component';
import { HistoriaComponent } from './pages/historia/historia.component';
import { ContatoComponent } from './pages/contato/contato.component';
import { VestuarioComponent } from './pages/vestuario/vestuario.component';
import { Projeto50Component } from './pages/projeto50/projeto50.component';
import { LoginComponent } from './pages/login/login.component';
import { CadastroComponent } from './pages/cadastro/cadastro.component';
import { FocushomeComponent } from './pages/focushome/focushome.component';
import { AcessoriosComponent } from './pages/acessorios/acessorios.component';
import { SustentavelComponent } from './pages/sustentavel/sustentavel.component';
import { CollabsComponent } from './pages/collabs/collabs.component';
import { FocusAppStoreComponent } from './pages/focusappstore/focusappstore.component';
import {  DownloadComponent } from './pages/downloadApp/download.component';

@NgModule({
  declarations: [
    SiteComponent,
    HomeComponent,
    EmpresaComponent,
    PropositoComponent,
    HistoriaComponent,
    ContatoComponent,
    VestuarioComponent,
    Projeto50Component,
    LoginComponent,
    CadastroComponent,
    FocushomeComponent,
    AcessoriosComponent,
    SustentavelComponent,
    CollabsComponent,
    FocusAppStoreComponent,
    DownloadComponent,
    AppIfairQAComponent
  ],
  imports: [
    NgbModule.forRoot(),
    CommonModule,
    NgbModule,
    SiteRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot()
  ]
})
export class SiteModule { }
